"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentShipmentExceptions = void 0;
var FulfillmentShipmentExceptions;
(function (FulfillmentShipmentExceptions) {
    FulfillmentShipmentExceptions["INVALID_SHIPMENT_STATE"] = "INVALID_SHIPMENT_STATE";
    FulfillmentShipmentExceptions["NOT_FOUND"] = "NOT_FOUND";
    FulfillmentShipmentExceptions["NOT_AT_WAREHOUSE"] = "NOT_AT_WAREHOUSE";
    FulfillmentShipmentExceptions["STOCKOUT"] = "STOCKOUT";
    FulfillmentShipmentExceptions["NO_RATES"] = "NO_RATES";
    FulfillmentShipmentExceptions["WEIGHT_UNAVAILABLE"] = "WEIGHT_UNAVAILABLE";
    FulfillmentShipmentExceptions["DIMENSIONS_UNAVAILABLE"] = "DIMENSIONS_UNAVAILABLE";
    FulfillmentShipmentExceptions["UNKNOWN_SKU"] = "UNKNOWN_SKU";
    FulfillmentShipmentExceptions["UNKNOWN_WAREHOUSE_STATUS"] = "UNKNOWN_WAREHOUSE_STATUS";
    FulfillmentShipmentExceptions["NO_SKUS_IN_ORDER"] = "NO_SKUS_IN_ORDER";
    FulfillmentShipmentExceptions["FAILED_TO_CANCEL"] = "FAILED_TO_CANCEL";
    FulfillmentShipmentExceptions["FAILED_TO_UNREGISTER_LINE_ITEMS"] = "FAILED_TO_UNREGISTER_LINE_ITEMS";
    FulfillmentShipmentExceptions["FAILED_TO_REGISTER_LINE_ITEMS"] = "FAILED_TO_REGISTER_LINE_ITEMS";
    FulfillmentShipmentExceptions["INVALID_WAREHOUSE"] = "INVALID_WAREHOUSE";
    FulfillmentShipmentExceptions["WAREHOUSE_ERR"] = "WAREHOUSE_ERR";
    FulfillmentShipmentExceptions["NO_BOXES"] = "NO_BOXES";
    FulfillmentShipmentExceptions["PARTIALLY_SHIPPED"] = "PARTIALLY_SHIPPED";
    FulfillmentShipmentExceptions["WAREHOUSE_NETWORK_ERR"] = "WAREHOUSE_NETWORK_ERR";
    FulfillmentShipmentExceptions["WAREHOUSE_UNKNOWN_ERR"] = "WAREHOUSE_UNKNOWN_ERR";
    FulfillmentShipmentExceptions["INVALID_WAREHOUSE_SHIP_METHOD"] = "INVALID_WAREHOUSE_SHIP_METHOD";
    FulfillmentShipmentExceptions["INVALID_WAREHOUSE_PACKAGE"] = "INVALID_WAREHOUSE_PACKAGE";
    FulfillmentShipmentExceptions["INVALID_PROPOSALS"] = "INVALID_PROPOSALS";
    FulfillmentShipmentExceptions["MISSING_TEST_DETAILS"] = "MISSING_TEST_DETAILS";
    FulfillmentShipmentExceptions["NO_FEDEX_RATES"] = "NO_FEDEX_RATES";
    FulfillmentShipmentExceptions["RELEASE_TIME_NOT_MET"] = "RELEASE_TIME_NOT_MET";
    FulfillmentShipmentExceptions["HAS_ACTIVE_LABELS"] = "HAS_ACTIVE_LABELS";
    FulfillmentShipmentExceptions["SHIPMENT_SHIPPED"] = "SHIPMENT_SHIPPED";
    FulfillmentShipmentExceptions["MORE_THAN_ONE_PACKAGE"] = "MORE_THAN_ONE_PACKAGE";
    FulfillmentShipmentExceptions["CANNOT_REPLACE_ZONE_SKIP_SHIPMENT"] = "CANNOT_REPLACE_ZONE_SKIP_SHIPMENT";
    FulfillmentShipmentExceptions["NO_INVENTORY_AT_FC"] = "NO_INVENTORY_AT_FC";
    FulfillmentShipmentExceptions["NO_INVENTORY_AT_SAME_SC"] = "NO_INVENTORY_AT_SAME_SC";
    FulfillmentShipmentExceptions["SHIPPING_METHOD_INACTIVE"] = "SHIPPING_METHOD_INACTIVE";
    FulfillmentShipmentExceptions["LABEL_PURCHASE_FAILURE"] = "LABEL_PURCHASE_FAILURE";
    FulfillmentShipmentExceptions["MISSING_SHIPPING_SPECIFICATIONS_FOR_HAZMAT"] = "MISSING_SHIPPING_SPECIFICATIONS_FOR_HAZMAT";
    FulfillmentShipmentExceptions["HAS_ACTIVE_REPLACEMENT"] = "HAS_ACTIVE_REPLACEMENT";
    FulfillmentShipmentExceptions["NO_SHIPMENT_PACKAGING"] = "NO_SHIPMENT_PACKAGING";
    FulfillmentShipmentExceptions["MISSING_TRANSFER_ORDER_DETAILS"] = "MISSING_TRANSFER_ORDER_DETAILS";
    FulfillmentShipmentExceptions["NOT_A_FREIGHT_SHIPMENT"] = "NOT_A_FREIGHT_SHIPMENT";
    FulfillmentShipmentExceptions["INCONSISTENT_SHIPMENTID"] = "INCONSISTENT_SHIPMENTID";
    FulfillmentShipmentExceptions["INVALID_SHIPMENT_WARNING"] = "INVALID_SHIPMENT_WARNING";
    FulfillmentShipmentExceptions["NOT_A_REMOVAL_ORDER"] = "NOT_A_REMOVAL_ORDER";
    FulfillmentShipmentExceptions["NO_ALLOWED_CARRIER_ACCOUNTS"] = "NO_ALLOWED_CARRIER_ACCOUNTS";
    FulfillmentShipmentExceptions["FAILED_TO_GET_WAREHOUSE_ATP"] = "FAILED_TO_GET_WAREHOUSE_ATP";
    FulfillmentShipmentExceptions["FAILED_TO_GET_PARCEL_RATES"] = "FAILED_TO_GET_PARCEL_RATES";
})(FulfillmentShipmentExceptions = exports.FulfillmentShipmentExceptions || (exports.FulfillmentShipmentExceptions = {}));
//# sourceMappingURL=FulfillmentShipmentExceptions.js.map